import { useSyncExternalStore } from "react";

/**
 * Masquage des lanceurs d'aide (bulle du support) demandé par un écran qui occupe le bas de l'écran, comme
 * l'assistant IA des e-mails : chaque demande rend une fonction qui la retire ; ils reviennent quand plus
 * aucune demande n'est active.
 */
let requests = 0;
const listeners = new Set<() => void>();

function emit(): void {
    listeners.forEach((listener) => listener());
}

export function hideHelpLaunchers(): () => void {
    requests += 1;
    emit();
    let released = false;

    return () => {
        if (released) return;
        released = true;
        requests = Math.max(0, requests - 1);
        emit();
    };
}

function subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

export function useHelpLaunchersHidden(): boolean {
    return useSyncExternalStore(subscribe, () => requests > 0);
}
